/**
 * Click-to-open header dropdowns.
 *
 * Horizon opens a submenu on hover, via the `on:pointerenter="/activate"` /
 * `on:focus="/activate"` bindings on each menu item in
 * `blocks/_header-menu.liquid`. Those bindings are omitted for items that have
 * a submenu; this file opens those on click instead.
 *
 * It drives the existing `<header-menu>` component through its public
 * `activate()` / `deactivate()` methods rather than duplicating any of the
 * height/aria bookkeeping, so `assets/header-menu.js` stays stock.
 */

const ITEM = '.menu-list__list-item';
const TRIGGER = '[ref="menuitem"]';
const SUBMENU = '[ref="submenu[]"]';

/**
 * Does this menu item own a submenu (as opposed to being a plain link)?
 * @param {Element} listItem
 * @returns {boolean}
 */
function hasSubmenu(listItem) {
  return Boolean(listItem.querySelector(`:scope > ${SUBMENU}`));
}

/**
 * Close whatever dropdown is currently open, in every header menu on the page.
 */
function closeOpenMenus() {
  document.querySelectorAll('header-menu').forEach((menu) => {
    const open = menu.querySelector(`${TRIGGER}[aria-expanded="true"]`);
    const listItem = open?.closest(ITEM);

    if (listItem && typeof (/** @type {any} */ (menu).deactivate) === 'function') {
      /** @type {any} */ (menu).deactivate({ target: listItem });
    }
  });
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  // Links inside an open dropdown must navigate as normal.
  const trigger = target.closest(SUBMENU) ? null : target.closest(TRIGGER);
  const listItem = trigger?.closest(ITEM);

  if (!listItem || !hasSubmenu(listItem)) {
    // A click anywhere else dismisses the dropdown.
    closeOpenMenus();
    return;
  }

  const menu = /** @type {any} */ (listItem.closest('header-menu'));
  if (typeof menu?.activate !== 'function' || typeof menu?.deactivate !== 'function') return;

  // The trigger is an <a href="#">; don't let it jump to the top of the page.
  event.preventDefault();

  if (trigger?.getAttribute('aria-expanded') === 'true') {
    menu.deactivate({ target: listItem });
  } else {
    menu.activate({ target: listItem });
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeOpenMenus();
});
